import React from "react";
import EntityManagement from "../../components/EntityManagement/EntityManagement";

const Customers = () => (
  <EntityManagement
    title="Customers"
    roleFilter="USER"
    subtitle="Sell-side customers only. Users with seller access enabled."
  />
);

export default Customers;
